module.exports = __webpack_public_path__ + "img/20c2eb8.jpg";